


















































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  Row,
  Col,
  Icon,
  Empty,
  Collapse,
  CollapseItem,
  Toast,
  Popup,
  Dialog
} from "vant";
import request from "@/api/index";
import { HotlineRes, HotlineRes_new } from "@/api/types";
import Native from "@/common/Native";
@Component({
  components: {
    Row,
    Col,
    Icon,
    Empty,
    Collapse,
    CollapseItem,
    Popup,
    Dialog: Dialog.Component
  }
})
export default class Hotline extends Vue {
  // 搜索关键词
  keyword = "";
  // 加载中
  loading = false;
  // 数据
  hotlineRows: any = [];
  // 渲染用的数据 因为搜索是前端做的 需要一个遍历搜索结果的渲染用变量
  renderHotlineRows: any = [];
  // 当前选择的
  current: Partial<{ name: string; phone: string }> = { name: "", phone: "" };
  // collapse
  showQueues: any = [];
  showChildQueues: any = {};
  // 拨号modal
  showCall = false;
  // 拨号modal 单号码
  showConfirm = false;
  inpBol: Boolean = false; //true为梁平，false为其他区县

  get isInApp() {
    return Native.isOpenInApp();
  }

  // appid从query参数中获取，默认23（梁平）
  getHotlineList() {
    Toast.loading({ message: "加载中...", duration: 0 });
    if (this.inpBol) {
      request
        .getHotlineList({
          appId: (this.$route.query.appid as string) || "23",
          sourceType: 9
        })
        .then(res => {
          if (!res.data) return;
          (res.data as any).forEach(
            (d: { name: string | number; secondClass: any[] }, i: any) => {
              this.showQueues.push([]);
              this.$set(this.showChildQueues, d.name, []);
              if (d.secondClass) {
                d.secondClass.forEach(() => {
                  this.showChildQueues[d.name].push([]);
                });
              }
            }
          );
          (this as any).hotlineRows = res.data || [];
          (this as any).renderHotlineRows = res.data || [];
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          Toast.clear();
        });
    } else {
      request
        .getHotlineList_other({
          appId: (this.$route.query.appid as string) || "23"
        })
        .then(res => {
          res.data.dataList.forEach(d => {
            this.showQueues.push([]);
          });
          this.hotlineRows = res.data.dataList || [];
          this.renderHotlineRows = res.data.dataList || [];
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          Toast.clear();
        });
    }
  }

  onInput() {
    if (!this.hotlineRows) return;
    if (!this.keyword.trim()) {
      this.renderHotlineRows = this.hotlineRows;
      this.showQueues = this.renderHotlineRows.map(() => []);
      for (let item in this.showChildQueues) {
        this.showChildQueues[item] = this.showChildQueues[item].map(() => []);
      }
      return;
    }
    // (this as any).renderHotlineRows = (this.hotlineRows
    //   .map((row, index) => {
    //     const matched = (row as any).secondClass.filter(
    //       r => r.name.indexOf(this.keyword.trim()) !== -1
    //     );
    //     matched.length && this.$set(this.showQueues, index, [row.name]);
    //     return matched.length
    //       ? {
    //           ...row,
    //           dataList: matched
    //         }
    //       : void 0;
    //   })
    //   .filter(Boolean) as unknown) as HotlineRes_new["dataRes"];

    // if (this.inpBol) return;
    // var endInp = setTimeout(() => {
    //   clearTimeout(endInp);
    //   this.inpBol = false;
    // console.log(this.inpBol, "<<<<<<<<<<<<<<<<<<<<<<<<<<<=this.inpBol");
    if (this.inpBol) {
      this.renderHotlineRows = JSON.parse(JSON.stringify(this.hotlineRows))
        .map(
          (
            row: { secondClass: any[]; nodes: any[]; name: string },
            index: any
          ) => {
            row.secondClass = row.secondClass
              ? row.secondClass
                  .map(
                    // item => item.name.indexOf(this.keyword.trim()) !== -1
                    (item, index2) => {
                      item.nodes = item.nodes.filter(
                        (item2: { name: string | string[] }, index3: any) => {
                          if (item2.name.indexOf(this.keyword.trim()) !== -1) {
                            this.$set(this.showChildQueues[row.name], index2, [
                              item.name
                            ]);
                            return true;
                          } else {
                            return false;
                          }
                        }
                      );
                      return item;
                    }
                  )
                  .filter(item => item.nodes.length)
              : [];
            row.nodes = row.nodes
              ? row.nodes.filter(
                  item => item.name.indexOf(this.keyword.trim()) !== -1
                )
              : [];
            return row;
          }
        )
        .filter(
          (
            item: {
              nodes: string | any[];
              secondClass: string | any[];
              name: any;
            },
            index: number
          ) => {
            this.$set(this.showQueues, index, [item.name]);
            return item.nodes.length || item.secondClass.length;
          }
        );
      this.showQueues = this.renderHotlineRows.map(() => []);
      for (let item in this.showChildQueues) {
        this.showChildQueues[item] = this.showChildQueues[item].map(() => []);
      }
    } else {
      this.renderHotlineRows = this.hotlineRows
        .map((row: { dataList: any[]; name: any }, index: string | number) => {
          const matched = row.dataList.filter(
            r => r.name.indexOf(this.keyword.trim()) !== -1
          );
          matched.length && this.$set(this.showQueues, index, [row.name]);
          return matched.length
            ? {
                ...row,
                dataList: matched
              }
            : void 0;
        })
        .filter(Boolean) as HotlineRes["dataList"];
    }

    // }, 500);
    // this.inpBol = true;
  }

  // 拨打电话
  tapCall(info: { name: string; phone: string }) {
    this.current = info;
    if (info.phone.split(",").length > 1) {
      this.showCall = true;
    } else {
      const ua = navigator.userAgent.toLowerCase();
      if ((ua.match(/MicroMessenger/i) as unknown) == "micromessenger")
        location.href = `tel://${this.current.phone}`;
      else this.showConfirm = true;
    }
  }

  // 确认拨打
  onConfirm() {
    location.href = `tel://${this.current.phone}`;
  }

  back() {
    Native.isOpenInApp() ? Native.close() : this.$router.back();
  }
  // 解决安卓机软键盘弹出页面挤压问题
  solveKeyboardSqueezeScreen() {
    const ua = navigator.userAgent,
      isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
    isAndroid &&
      this.$nextTick(() => {
        const vw = window.innerWidth,
          vh = window.innerHeight,
          viewport = document.querySelector("meta[name=viewport]")!;

        viewport.setAttribute(
          "content",
          "height=" + vh + "px, width=" + vw + "px, initial-scale=1.0"
        );
      });
  }
  created() {
    this.inpBol = this.$route.query.appid
      ? this.$route.query.appid == "23"
      : true;
    Native.isOpenInApp() &&
      ZWY_CLOUD.topBarConfig({
        isShowTop: this.$route.query.appid == "18" ? 0 : 1,
        isShowBackBtn: 1,
        isShowTitle: "一键拨打",
        isShowMoreBtn: "0"
      });
  }

  mounted() {
    document.title = "一键拨打";
    this.solveKeyboardSqueezeScreen();
    this.getHotlineList();
  }
}
